export { default } from './InputBase';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/InputBase/index.js
// module id = 153
// module chunks = 0